import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxDaterangepickerMd,DaterangepickerComponent } from 'ngx-daterangepicker-material';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';


//Component
import { SuperAdminAccountsComponent } from './superadminaccounts/superadminaccounts.component';
import { ComponentsSettingsComponent } from './componentsettings/componentssettings.component';

//Module
import { ImageUploaderModule } from '../control/image-uploader/image-uploader.module';
import { SharedModule } from '../../shared/shared.module';
import { FileUploaderModule } from '../control/file-uploader/file-uploader.module';

export const routes = [
  { path: '', redirectTo: 'componentssettings', pathMatch: 'full'},
  { path: 'superadminaccounts', component: SuperAdminAccountsComponent, data: { breadcrumb: 'Super Administrator Accounts' } },
  { path: 'componentssettings', component: ComponentsSettingsComponent, data: { breadcrumb: 'TMS Components Settings' } },
      
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxPaginationModule,
    ImageUploaderModule,
    NgxDatatableModule,
    FileUploaderModule,
    NgxLoadingModule,   
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.threeBounce,
      backdropBackgroundColour: 'rgba(0, 0, 0, 0)',
      backdropBorderRadius: '4px',
      primaryColour: '#666666',
      secondaryColour: '#666666',
      tertiaryColour: '#666666'
    }),
    SharedModule,
    NgxDaterangepickerMd.forRoot(),

  ],
  declarations: [
    SuperAdminAccountsComponent,
    ComponentsSettingsComponent

  ],
  providers: [  ],
  entryComponents: [DaterangepickerComponent]
})
export class SuperAdminModule { }